/* eslint-disable */
import { gsap } from 'gsap';
import { SplitText } from 'gsap/SplitText'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { MorphSVGPlugin } from 'gsap/MorphSVGPlugin'
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
import imagesloaded from 'imagesloaded'
import Swiper, { Pagination } from 'swiper'
import Glightbox from 'glightbox'
import 'lazysizes'
import { ScrollToPlugin } from "gsap/ScrollToPlugin"

Swiper.use(Pagination)

Glightbox({
    openEffect: 'fade',
    closeEffect: 'fade',
    loop: false
});

// import { GSDevTools } from "gsap/GSDevTools";
// gsap.registerPlugin(GSDevTools)
// GSDevTools.create();

gsap.registerPlugin(SplitText)
gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(MorphSVGPlugin)
gsap.registerPlugin(DrawSVGPlugin)
gsap.registerPlugin(ScrollToPlugin)

/*
 * Hero Animation
 */
const heroHeading = document.querySelector('.lp-hero__heading')
const heroHeadingSplit = new SplitText(heroHeading, {
    type: "words"
})

if (heroHeading) {
    const heroTimeline = gsap.timeline({
        id: "heroTimeline",
        paused: true,
    })

    heroTimeline.to('.lp-hero__background-image', {
        autoAlpha: 1,
        duration: 1,
    })

    heroTimeline.to('.lp-hero__background-logo', {
        autoAlpha: 1,
        duration: 4,
    })

    heroTimeline.to('.lp-hero__icon', {
        autoAlpha: 1,
        duration: 1,
    }, "<")

    heroTimeline.fromTo('.lp-hero__eyebrow span', {
        yPercent: 100,
    }, {
        autoAlpha: 1,
        yPercent: 0,
        duration: 1,
        ease: "power4.out"
    }, ">-.5")

    heroTimeline.to(heroHeadingSplit.words, {
        duration: 2,
        autoAlpha: 1,
        stagger: {
            each: 0.4,
        },
    }, ">-.5")

    heroTimeline.to('.lp-hero__copy', {
        autoAlpha: 1,
        duration: 1,
    }, ">-1.6")

    imagesloaded('.lp-hero', () => {
        setTimeout(() => {
            gsap.set(heroHeading, {
                opacity: 1,
            })
            heroTimeline.play()
        }, 750)
    })
}
/**
 * Hero Scroll Effects
 */
if (document.querySelector('.lp-hero1')) {
    const heroScrollTriggerOptions = {
        trigger: '.lp-hero',
        start: 'top top',
        end: 'bottom top',
        scrub: true,
    }

    gsap.to('.lp-hero__wrapper', {
        autoAlpha: 0,
        scrollTrigger: heroScrollTriggerOptions
    })

    gsap.to('.lp-hero__background-image, .lp-hero__video', {
        yPercent: 10,
        scrollTrigger: heroScrollTriggerOptions
    })
}
/**
 * Trail Draw
 */
const trailSvg = document.querySelector('.lp-path-select__trail')

if(trailSvg) {
    const trailCover = trailSvg.querySelector('.trail-cover')
    const markerOne = trailSvg.querySelector('.marker-1')
    const markerTwo = trailSvg.querySelector('.marker-2')
    const trailTimeline = gsap.timeline({
        scrollTrigger: {
            trigger: '.lp-path-select',
            start: 'top center',
        }
    })

    trailTimeline.to(trailCover, {
        drawSVG: 0,
        duration: 4,
    })
    trailTimeline.to(markerTwo, {
        autoAlpha: 1,
    }, ">-.8")

    trailTimeline.to(markerOne, {
        autoAlpha: 1,
    }, ">-.3")
}

/**
 * Adventure Trail Draw
 */
 const trailSvg2 = document.querySelector('.adventureDessign__trail')

 if(trailSvg2) {
    const trailCover = trailSvg2.querySelector('#maskPath')
    const trailTimeline = gsap.timeline({ scrollTrigger: { start: 150, } })

    trailTimeline.from(trailCover, {
        duration: 4,
        drawSVG: 0,
        ease: "none",
      });
      
 }

/**
 * Scroll to Sections
 */
document.querySelectorAll('.lp-path-card a').forEach(pathLink => {
    pathLink.addEventListener('click', (event) => {
        event.preventDefault()
        const targetSection = document.getElementById(pathLink.hash.replace('#', ''))
        const offsetY = targetSection.querySelector('.lp-info-bar') ? targetSection.querySelector('.lp-info-bar').clientHeight : 0
        gsap.to(window, {
            duration: 0,
            scrollTo: {
                y: pathLink.hash,
                offsetY
            }
        })
    })
})

/**
 * Product Feature Animation
 */
document.querySelectorAll('.lp-product-feature').forEach(section => {
    const productCards = section.querySelectorAll('.lp-product-card')
    const productReel = section.querySelector('.lp-product-feature__product-reel')
    let targetSlide;
    let timeline;
    let firstAnimation = true

    const generateTimeline = (slide, includeButton) => {
        const slideImage = slide.querySelector('.lp-spotlight__slide-image')
        const slideBg = slide.querySelector('.lp-spotlight__slide-bg')
        const slideContent = slide.querySelector('.lp-spotlight__slide-content')
        const slideHeading = slide.querySelector('.lp-spotlight__slide-heading')
        const slideCopy = slide.querySelector('.lp-spotlight__slide-copy')
        const slideButton = slide.querySelector('.lp-spotlight__slide-button')

        const slideTimeline = gsap.timeline({
            paused: true
        })

        slideTimeline.to(slide, {
            duration: 0,
            css: {
                pointerEvents: 'auto'
            },
        })

        slideTimeline.to(slideBg, {
            x: 0,
            skewX: 0,
            ease: "out.power3"
        })

        slideTimeline.to(slideImage, {
            x: 0,
            ease: "out.power3",
        }, "<+.2")

        slideTimeline.to(slideContent, {
            y: 0,
            duration: .6,
            ease: "out.power3",
        }, 0)

        slideTimeline.to([slideHeading, slideCopy], {
            autoAlpha: 1,
            duration: .4,
            delay: .3,
        }, 0)

        if (includeButton) {
            slideTimeline.to(slideButton, {
                autoAlpha: 1,
                duration: 0.2,
                ease: "linear",
            }, "<")
        }

        return slideTimeline
    }

    productCards.forEach(card => {
        let timeoutId

        const desktopIn = () => {
            targetSlide = section.querySelector(`.lp-spotlight__slide[data-slide="${card.dataset.slideIndex}"]`)
            timeline = generateTimeline(targetSlide)
            timeline.reversed(false).timeScale(1)
            timeoutId = setTimeout(() => {
                timeline.play()
            }, firstAnimation ? 0 : 300)

            firstAnimation = false
        }

        const desktopOut = () => {
            clearTimeout(timeoutId)
            timeline.reversed(true).timeScale(2)
            timeline.reverse()
        }

        const mobileInOut = (event) => {
            productCards.forEach(card => card.classList.remove('is-active'))
            event.currentTarget.classList.add('is-active')
            const timeout = timeline ? 300 : 0;
            if (timeline) {
                timeline.reversed(true).timeScale(2)
                timeline.reverse()
            }

            setTimeout(() => {
                targetSlide = section.querySelector(`.lp-spotlight__slide[data-slide="${card.dataset.slideIndex}"]`)
                timeline = generateTimeline(targetSlide, true)
                timeline.reversed(false).timeScale(1)
                timeline.play()
            }, timeout)
        }

        ScrollTrigger.matchMedia({
            "(max-width: 1200px)": function() {
                card.addEventListener('click', mobileInOut)
                card.removeEventListener('mouseenter', desktopIn)
                card.removeEventListener('mouseleave', desktopOut)
            },
            "(min-width: 1201px)": function() {
                card.addEventListener('mouseenter', desktopIn)
                card.addEventListener('mouseleave', desktopOut)
                productReel.addEventListener('mouseleave', () => firstAnimation = true)
                card.removeEventListener('click', mobileInOut)
                gsap.set('.lp-spotlight__slide-bg', {clearProps: "transform"})
                gsap.set('.lp-spotlight__slide-image', {clearProps: "transform"})
                gsap.set('.lp-spotlight__slide-content', {clearProps: "transform"})
                gsap.set('.lp-spotlight__slide-button', {clearProps: "opacity"})
            }
        });
    })
})

/**
 * Product Slider
 */
let swipers = []
ScrollTrigger.matchMedia({
    "(max-width: 800px)": function() {
        const sliders = document.querySelectorAll('.lp-product-feature__product-reel .swiper-container')
        sliders.forEach(slider => {
            swipers.push(new Swiper(slider, {
                slidesPerView: 'auto'
            }))
        })
    },
    "(min-width: 801px)": function() {
        swipers.forEach(swiper => swiper.destroy())
    }
});

/**
 * Info Bar
 */
let infoSliders = [];
document.querySelectorAll('.lp-product-feature').forEach((section) => {
    const infoBar = section.querySelector('.lp-info-bar')
    if (infoBar) {
        ScrollTrigger.create({
            trigger: section,
            start: `top top+=${infoBar.clientHeight + 100}px`,
            end: `bottom top+=${infoBar.clientHeight}px`,
            toggleClass: {
                targets: infoBar,
                className: "is-active",
            }
        })

        ScrollTrigger.matchMedia({
            "(max-width: 1200px)": function() {
                const slider = infoBar.querySelector('.swiper-container')
                infoSliders.push(new Swiper(slider, {
                    slidesPerView: 1,
                    pagination: {
                        el: '.swiper-pagination',
                    },
                    breakpoints: {
                        800: {
                            slidesPerView: 2
                        }
                    }
                }))
            },
            "(min-width: 1201px)": function() {
                infoSliders.forEach(infoSlider => infoSlider.destroy())
            }
        });
    }
})

/**
 * Product Card Links
 */
const productCards = document.querySelectorAll('.lp-product-card')

const handleProductCardClick = (productCard) => () => {
    let elMainLink
    const links = productCard.getElementsByTagName('a')
    const isTextSelected = window.getSelection().toString()

    elMainLink = productCard.querySelector('[data-main-link]')

    // Prevent double link clicks
    Array.from(links).forEach((elLink) => {
        elLink.addEventListener('click', function (event) {
            event.stopPropagation()
        })
    })

    // No main link specified, grab the 1st link in the card
    if (!elMainLink) {
        [elMainLink] = links
    }

    if (!isTextSelected) {
        elMainLink.click()
    }
}

ScrollTrigger.matchMedia({
    "(max-width: 1200px)": function() {
        productCards.forEach(productCard => productCard.removeEventListener('click', handleProductCardClick))
    },
    "(min-width: 1201px)": function() {
        productCards.forEach(productCard => productCard.addEventListener('click', handleProductCardClick(productCard)))
    }
})
